import { 
  React, 
  TextFieldProps, 
  Typography, 
  DatePicker, 
  DatePickerProps, 
  LocalizationProvider, 
  AdapterDayjs 
} from '../../utils/globalImports';
import dayjs, { Dayjs } from 'dayjs';
import { DateValidationError } from '@mui/x-date-pickers/models';

interface CustomDatePickerProps extends Omit<DatePickerProps<any>, 'renderInput'> {
  textFieldProps?: TextFieldProps;
  label?: string;
  sx?: object;
  required?: boolean;
  height?: number;
  disable?: boolean;
  disableOldDate?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  value,
  onChange,
  textFieldProps,
  label,
  sx,
  required = false,
  height = 35,
  disable,
  disableOldDate = false,
  ...props
}) => {
  const handleDateChange = (
    newValue: Dayjs | null,
    context?: any // 👈 avoid importing internal types
  ) => {
    if (!newValue) {
      onChange?.(null as any, context);
      return;
    }

    if (newValue.isValid()) {
      const year = newValue.year();
      if (year >= 1000) {
        onChange?.(newValue as any, context);
      }
    }
  };

  return (
    <div>
      {required && (
        <Typography 
          variant="subtitle1" 
          sx={{ display: 'block', color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1 }}
        >
          {label}
          <span style={{ color: 'red' }}>*</span>
        </Typography>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          format="DD/MM/YYYY"
          value={value}
          onChange={handleDateChange}
          disabled={disable}
          disablePast={disableOldDate}
          {...props}
          slotProps={{
            textField: {
              placeholder: label || 'DD/MM/YYYY',
              ...textFieldProps,
              inputProps: { inputMode: 'numeric' },
              sx: {
                ...sx,
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '50px',
                  minHeight: height,
                },
                '& .MuiInputBase-input': {
                  paddingLeft: '15px',
                  fontSize: '14px',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                  lineHeight: '1.5',
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default CustomDatePicker;
